module.exports = __webpack_public_path__ + "static/media/telephone.145f9f30.svg";